import { type MouseEvent, memo } from 'react';

import { WorkspaceAgentGuidedVariantSizeGroupToggle } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/WorkspaceAgentGuidedVariantSizeGroupToggle';
import { WorkspaceAgentGuidedVariantSizeOptionRow } from '~/components/v2/components/workspace/workspace-agent-panel/components/composer/guided-variants/WorkspaceAgentGuidedVariantSizeOptionRow';
import {
  isWorkspaceAgentSmartResizeSizeSelected,
  WORKSPACE_AGENT_SMART_RESIZE_EXACT_SIZE_OPTION_ROW_CHANNEL,
  WORKSPACE_AGENT_SMART_RESIZE_SHAPES,
  type WorkspaceAgentSmartResizeSize,
  workspaceAgentSmartResizeShapeOptionToOptionRowChannel,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentSmartResize';

export type WorkspaceAgentGuidedVariantSmartResizeShapeGroupProps = {
  isExactMode: boolean;
  isExpanded: boolean;
  onExactSize: () => void;
  onSelectSize: (event: MouseEvent<HTMLButtonElement>) => void;
  onToggle: (event: MouseEvent<HTMLButtonElement>) => void;
  sizes: readonly WorkspaceAgentSmartResizeSize[];
};

export const WorkspaceAgentGuidedVariantSmartResizeShapeGroup = memo(
  ({
    isExactMode,
    isExpanded,
    onExactSize,
    onSelectSize,
    onToggle,
    sizes,
  }: WorkspaceAgentGuidedVariantSmartResizeShapeGroupProps) => (
    <div>
      <WorkspaceAgentGuidedVariantSizeGroupToggle
        groupId="shape"
        isExpanded={isExpanded}
        label="Shape"
        onToggle={onToggle}
      />
      {isExpanded ? (
        <div className="flex flex-col pl-6">
          {WORKSPACE_AGENT_SMART_RESIZE_SHAPES.map((shape) => {
            const { channel, meta } = workspaceAgentSmartResizeShapeOptionToOptionRowChannel(shape);
            const isSelected = isWorkspaceAgentSmartResizeSizeSelected(sizes, shape.size);

            return (
              <WorkspaceAgentGuidedVariantSizeOptionRow
                channel={channel}
                isSelected={isSelected}
                key={shape.id}
                meta={meta}
                onClick={onSelectSize}
              />
            );
          })}
          <WorkspaceAgentGuidedVariantSizeOptionRow
            channel={WORKSPACE_AGENT_SMART_RESIZE_EXACT_SIZE_OPTION_ROW_CHANNEL}
            data-testid="WORKSPACE_AGENT_GUIDED_VARIANT_SMART_RESIZE_EXACT"
            isSelected={isExactMode}
            leading={
              <span aria-hidden className="flex size-4 shrink-0 items-center justify-center">
                <span className="size-3 rounded-2 ads:border-ads-gray-9 border-[1.5px] border-gray-9 border-dashed" />
              </span>
            }
            onClick={onExactSize}
            showSelectionMark={false}
          />
        </div>
      ) : null}
    </div>
  ),
);

WorkspaceAgentGuidedVariantSmartResizeShapeGroup.displayName = 'WorkspaceAgentGuidedVariantSmartResizeShapeGroup';
